const SECTION_MODEL_CLASS_NAME = 'Section'

const SECTION_MODEL_KEY = {
  ID: 'id',
  CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  NAME: 'name',
  CATEGORIES: 'categories',
  TAGS: 'tags'
}

const SECTION_MODEL_KEY_POINTER = SECTION_MODEL_KEY.NAME

module.exports = {
  SECTION_MODEL_CLASS_NAME,
  SECTION_MODEL_KEY,
  SECTION_MODEL_KEY_POINTER
}
